"use strict";

let _ = require("lodash");
let $ = require("jquery");
let renderMain = require("./main.ejs");
let renderItem = require("./item.ejs");
let renderImage = require("./item_img.ejs");
let Uploader = require("./uploader");
let eventize = require("./eventize");


/**
 * options:
 *   - container    (required)
 *   - uploadUrl    (required)
 *   - downloadUrl  (required)
 *   - deleteUrl    На этот url отправляются id файла и context методом POST, ответ 200 считается успешным удалением.
 *                  Если не передан, удаление происходит только в виджете
 *   - maxQuantity
 *   - fileType
 *   - readonly     bool
 *   - context
 *
 *item
 * @param options
 * @param files
 * @constructor
 */
let UploaderWidget = function (options, files) {
    this.files = files;

    this.downloadUrl = options.downloadUrl;
    this.uploadUrl = options.uploadUrl;
    this.deleteUrl = options.deleteUrl;
    this.maxQuantity = options.maxQuantity;
    this.maxSize = options.maxSize;
    this.fileType = options.fileType;
    this.context = options.context;

    this.uploader = null;
    this.id = UploaderWidget.seq++;

    this.element = this.render(options.readonly);

    $(this.element).appendTo(options.container);
};

eventize(UploaderWidget.prototype);

UploaderWidget.seq = 1;

UploaderWidget.prototype.render = function (readonly) {
    let me = this;

	let form = $(renderMain({
        item: me.files,
        itemTemplate: renderItem,
        imgItemTemplate: renderImage,
        url: me.downloadUrl,
        widgetId: me.id,
        readonly: readonly
    }));

    if (!readonly) {
        me.uploader = new Uploader({container: form, url: me.uploadUrl, accept: me.fileType, maxs: me.maxSize})
			.on('success', function (file) {
				if (me.maxQuantity && me.files.length >= me.maxQuantity) {
					return;
				}
				me.files.push(file);

				if (me.maxQuantity && me.files.length >= me.maxQuantity) {
					this.disable();
				}

				let is_img = !!file.mime.match(/^image/);

				let render = is_img ? renderImage : renderItem;

				$(is_img ? '.filelist-items-img' : '.filelist-items', form).append(render({
					item: file,
					url: me.downloadUrl,
					widgetId: me.id
				}));

				me.trigger('change', me.files);
			});

        if (me.maxQuantity && me.files.length >= me.maxQuantity) {
            me.uploader.disable();
        }

        form.on('click', '.filelist-delete, .filelist-delete-img', function() {
			let btn = $(this);
			let id = btn.data('id');
			let backendDeleting;

            for (let i = me.files.length; i--;) {
                if (me.files[i].id == id) {

                    if (me.deleteUrl) {
                        backendDeleting = $.post(me.deleteUrl, {
                            id: id,
                            context: me.getContext()
                        });
                    } else {
                        backendDeleting = $.Deferred().resolve().promise();
                    }

                    backendDeleting.done(function () {
                        for (let i = me.files.length; i--;) {
                            if (me.files[i].id == id) {
                                me.files.splice(i, 1);
                                btn.closest('.filelist-item, .filelist-item-img').remove();

                                if (me.maxQuantity && me.files.length < me.maxQuantity) {
                                    me.uploader.enable();
                                }

                                me.trigger('change', me.files);
                                break;
                            }
                        }
                    });

                    break;
                }
            }
        });
    }

    return form[0];
};

UploaderWidget.prototype.getContext = function () {
    if (typeof this.context == "function") {
        return this.context(this);
    }

    return this.context;
};

module.exports = UploaderWidget;
global.UploaderWidget = UploaderWidget;